import {
  MailSend01Icon,
  Mail01Icon,
  BubbleChatIcon,
  Call02Icon,
  NoteEditIcon,
  Message02Icon
} from "@hugeicons-pro/core-stroke-rounded";
import type { Tab } from "shared/components/BaseTabs";
import type { MessageChannel } from "../types";

export type ComposerTab = "email" | "sms" | "voice" | "note" | "chat";

// Channels handled by the textual ComposerForm. "voice" is rendered separately
// (the softphone has its own UI), so we narrow the form's accepted set here.
export type ComposerFormChannel = "email" | "sms" | "note" | "chat";

const COMPOSER_TABS: ComposerTab[] = ["email", "sms", "voice", "note", "chat"];

const composerTabConfig: Record<
  ComposerTab,
  { icon: typeof Mail01Icon; label: string }
> = {
  email: { icon: Mail01Icon, label: "Email" },
  sms: { icon: BubbleChatIcon, label: "SMS" },
  voice: { icon: Call02Icon, label: "Call" },
  note: { icon: NoteEditIcon, label: "Manual" },
  chat: { icon: Message02Icon, label: "Chat" }
};

export const composerTabs: Tab<ComposerTab>[] = COMPOSER_TABS.map((tab) => ({
  value: tab,
  label: composerTabConfig[tab].label,
  leftElement: { type: "icon", component: composerTabConfig[tab].icon }
}));

const composerTabParam: Record<ComposerTab, string | undefined> = {
  email: undefined,
  sms: "sms",
  voice: "voice",
  note: "manual",
  chat: "chat"
};

export const applyComposerTabParam = (
  params: URLSearchParams,
  tab: ComposerTab
) => {
  const value = composerTabParam[tab];
  if (value) params.set("tab", value);
  else params.delete("tab");
  return params;
};

// Inverse of applyComposerTabParam. The two vocabularies differ: the URL spells
// the Manual tab "manual" while the ComposerTab value is "note". Anything
// unrecognised (a host page's own `?tab=`) falls back to email.
export const parseComposerTabParam = (value: string | null): ComposerTab => {
  if (!value) return "email";
  return (
    COMPOSER_TABS.find((tab) => composerTabParam[tab] === value) ?? "email"
  );
};

export const channelConfig: Record<
  MessageChannel,
  { icon: typeof MailSend01Icon; label: string }
> = {
  email: {
    icon: MailSend01Icon,
    label: "Email"
  },
  sms: {
    icon: BubbleChatIcon,
    label: "SMS"
  },
  voice: {
    icon: Call02Icon,
    label: "Call"
  },
  note: {
    icon: NoteEditIcon,
    label: "Manual record"
  },
  chat: {
    icon: BubbleChatIcon,
    label: "Chat"
  }
};
